/**
 * Where to send an unavailable product (item/combo/picker) after store menu settle.
 *
 * - Parent section exists at the store → pin the item in that section.
 * - Parent section missing / unknown, but Full Menu has other categories → Full Menu
 *   with the product Not Available card + other available options.
 * - Otherwise → PDP fallback (MenuItemUnavailable + Tap-here).
 */
export type UnavailableProductRecovery =
  | { kind: 'section'; sectionId: string }
  | { kind: 'fullMenu'; itemId: string; sectionId?: string }
  | { kind: 'fallback' };

export function resolveUnavailableProductRecovery({
  itemId,
  sectionId,
  sectionExistsAtStore,
  hasOtherMenuSections,
}: {
  itemId: string;
  sectionId: string | undefined;
  sectionExistsAtStore: boolean;
  hasOtherMenuSections: boolean;
}): UnavailableProductRecovery {
  if (sectionId && sectionExistsAtStore) {
    return { kind: 'section', sectionId };
  }

  if (itemId && hasOtherMenuSections) {
    return {
      kind: 'fullMenu',
      itemId,
      ...(sectionId ? { sectionId } : {}),
    };
  }

  return { kind: 'fallback' };
}
